module.exports = __webpack_public_path__ + "assets/home-min.adae7de5fb9793abbbc54b93cd061c1f.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/AliciaVogel/home-min.jpg
 ** module id = 424
 ** module chunks = 0
 **/